export const DEFAULT_CRM_TOKEN = '2ysz1dvfru';
export const brandLogo = `${window.assetsLocation}/images/showcase.jpg`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.jpg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const homeArticleIds = ['9'];
export const faqArticleIds = ['4', '5', '6', '7', '8'];
